import { Typography } from '@hiiretail/react-foundation-ui';
import { memo } from 'react';
import { useIntl } from 'react-intl';

const styles = {
  textTransform: 'uppercase',
  color: 'primary.main',
  fontSize: 26,
  mt: 1,
};

export const NewReceiptTitle = memo(() => {
  const intl = useIntl();

  return <Typography sx={styles}>{intl.formatMessage({ id: 'receipt.new' })}</Typography>;
});
